import { TacheService } from './../../../../services/tache.service';
import { CurrentUserService } from './../../../../services/currentUserService';
import { Utilisateur } from './../../../../models/utilisateur.model';
import { User } from './../../../../@core/data/users';
import { HistoTacheService } from './../../../../services/histotache.service';
import { Historiquetache } from './../../../../models/historiqueTache.model';
import { Component, OnInit, Input } from '@angular/core';
import { TabService } from '../../../../services/tab.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalDataSource } from 'ng2-smart-table';
import { Tache } from '../../../../models/tache.model';
import { DatePipe } from '@angular/common';
import { NbToastrService } from '@nebular/theme';
import { UserData } from '../../../../@core/data/users';
import { NbAuthService } from '@nebular/auth';

var DateDiff = require('date-diff');

@Component({
  selector: 'app-tabCulture',
  templateUrl: './tabCulture.component.html',
  styleUrls: ['./tabCulture.component.scss']
})
export class TabCultureComponent implements OnInit {

  @Input() culture: Tache[];
  defaultOrdre: number;
  source: LocalDataSource;
  constructor(private tacheService:TacheService, private currentUserService:CurrentUserService, private authService: NbAuthService, private datePipe: DatePipe,private tabService: TabService, private translate: TranslateService,private histoTacheService: HistoTacheService,private toastrService: NbToastrService) {

  }

  ngOnInit() {
  }

 timeConvert(n:any) {
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return  rhours + " hour(s) and " + rminutes + " minute(s).";
  };

  
  settings = {
    pager: {
      display: true,
      perPage: 5
    },
    actions: { add:false, delete: false },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave: true,
      mode: 'inline',
    },
    columns: {
      tache_etagereId: {
        title: this.translate.instant('Etagère'),
        type: 'string',
        editable: false
      },
      tache_statut: {
        title: this.translate.instant('Statut'),
        type: 'date',
        valuePrepareFunction: (value) => {
          value = this.translate.instant('STATUS_' + value);
          return  value ;

        },
        editable: false
      },
      typetache_libelle: {
        title: this.translate.instant('Type tâche'),
        type: 'string',
        editable: false,
      },
      tache_datedebuttache: {
        title: this.translate.instant('Date début tache'),
        type: 'date',
        editable: false,
        valuePrepareFunction: (date) => { 
          var formatted = this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss');
          return formatted; 
        }
      },
      tache_datefintache: {
        title: this.translate.instant('Date fin tache'),
        type: 'date',
        editable: false,
        valuePrepareFunction: (date) => { 
          var formatted = this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss');
          return formatted; 
        }
      },
      tempsRestant: {
        title: this.translate.instant('Temps restant'),
        type: 'date',
        editable: false,
        valuePrepareFunction:  (cell, row) => {
          var dateNow = new Date(); 
          var dateFinTache = new Date(row.tache_datefintache);
          var diff = new DateDiff(dateFinTache, dateNow);
          return this.timeConvert(diff.minutes());
        }
      },
    },
    rowClassFunction: (row) => {
      if (this.translate.instant('STATUS_' + row.data.tache_statut) === 'Terminé') {
          return 'termine';
      } else {
          return 'enCours';
      }
    },
  };

  onEditConfirm(event): void {
   
    if (window.confirm(this.translate.instant('TACHE_EDIT_CONFIRM'))) {
      
      event.newData["utilisateurId"] = this.currentUserService.user;
      this.tacheService.update_tache(event.newData)
      .subscribe(response => {
        event.newData = response;
        console.log(response);
        for (let property in event.newData) {
          const value = event.newData[property];
          delete event.newData[property];
          property = "tache_" + property;
          event.newData[property] = value;
         }
        event.confirm.resolve(event.newData);
        console.log(event.newData);
        this.toastrService.success(this.translate.instant('TASK_MODIFIED'),
        this.translate.instant('SUCCESS'));
       
        this.histoTacheService.createHistotaches(event.newData)
          .subscribe(response => {
          this.toastrService.success(this.translate.instant('TASK_MODIFIED'),
          this.translate.instant('SUCCESS'));
        
          },
          (err) => {
            err.error.forEach(error => {
              this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
                                        this.translate.instant('ERROR_INVALID_TYPE'));
            });
          });

      },
      (err) => {
        err.error.forEach(error => {
          this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
                                    this.translate.instant('ERROR_INVALID_TYPE'));
        });
      });

      
      this.histoTacheService.createHistotaches(event.newData)
      .subscribe(response => {
        event.confirm.resolve(event.newData);
        this.toastrService.success(this.translate.instant('TASK_MODIFIED'),
        this.translate.instant('SUCCESS'));
        
      },
      (err) => {
        err.error.forEach(error => {
          this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
                                    this.translate.instant('ERROR_INVALID_TYPE'));
        });
      });

    } else {
      event.confirm.reject();
    }

  
  }
}
